import { nanoid } from "nanoid";
import { FlowModuleItemType, ModuleItemType } from "@packages/flow-core/module";
import { EDGE_TYPE } from "@packages/flow-core/module/node/constants";
import { Edge, Node } from "reactflow";

export const appModule2FlowNode = ({
  item,
}: {
  item: ModuleItemType;
}): Node<FlowModuleItemType> => {
  // init some static data
  // const template =
  //   moduleTemplatesFlat.find((template) => template.flowType === item.flowType) || UserChatInputModule;

  // const concatInputs = template.inputs.concat(
  //   item.inputs.filter((input) => !template.inputs.find((item) => item.key === input.key)),
  // );
  // const concatOutputs = item.outputs.concat(
  //   template.outputs.filter(
  //     (templateOutput) => !item.outputs.find((item) => item.key === templateOutput.key),
  //   ),
  // );

  // replace item data
  const moduleItem: FlowModuleItemType = {
    // ...template,
    ...item,
    id: item.moduleId,
    avatar: item.avatar,
    inputs: item.inputs.map((templateInput) => {
      // use latest inputs
      const itemInput =
        item.inputs.find((item) => item.key === templateInput.key) ||
        templateInput;
      return {
        ...templateInput,
        value: itemInput.value,
      };
    }),
    outputs: (item.outputs || []).map((output) => {
      // unChange outputs
      const templateOutput = item.outputs.find(
        (item) => item.key === output.key
      );

      return {
        ...(templateOutput ? templateOutput : output),
        targets: output.targets || [],
      };
    }),
  };

  return {
    id: item.moduleId,
    type: item.flowType,
    data: moduleItem,
    position: item.position || { x: 0, y: 0 },
  };
};

export const appModule2FlowEdge = ({
  modules,
}: {
  modules: ModuleItemType[];
}) => {
  const edges: Edge[] = [];
  modules.forEach((module) =>
    module.outputs?.forEach((output) =>
      output.targets.forEach((target) => {
        edges.push({
          source: module.moduleId,
          target: target.moduleId,
          sourceHandle: output.key,
          targetHandle: target.key,
          id: nanoid(),
          type: EDGE_TYPE,
        });
      })
    )
  );

  return edges;
};
